import { Button, Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { ModalProvider } from 'vig-ui-library';
import { useMagicLinkAppProvider } from '@/Provider/MagicLinkAppProvider';
import BottomSheet from '@/Components/MagicLink/BottomSheet';

export type CancelRequestButtonProps = {
    fullWidth?: boolean;
};

const CancelRequestButton = ({ fullWidth = true }: CancelRequestButtonProps) => {
    const { cancelRequestTask } = useMagicLinkAppProvider();
    const { openConfirmModal } = ModalProvider.useModal();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

    const handleOpen = () => {
        if (isMobile) {
            setIsBottomSheetOpen(true);
        } else {
            openConfirmModal({
                title: 'Zrušiť žiadosť',
                description: 'Naozaj chcete zrušiť túto žiadosť? Táto akcia je nezvratná.',
                confirmText: 'Potvrdiť zrušenie',
                cancelText: 'Zrušiť',
                onConfirm: async () => {
                    await cancelRequestTask.perform();
                },
            });
        }
    };

    const handleConfirm = async () => {
        await cancelRequestTask.perform();
        setIsBottomSheetOpen(false);
    };

    const handleCloseBottomSheet = () => {
        setIsBottomSheetOpen(false);
    };

    return (
        <>
            <Button
                variant="text"
                fullWidth={fullWidth}
                onClick={handleOpen}
                sx={{
                    textTransform: 'none',
                    color: 'text.secondary',
                    fontWeight: 500,
                }}
            >
                Zrušiť žiadosť
            </Button>

            {isMobile && (
                <BottomSheet open={isBottomSheetOpen} onClose={handleCloseBottomSheet}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="h6" component="h2">
                                Zrušiť žiadosť
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Naozaj chcete zrušiť túto žiadosť? Táto akcia je nezvratná.
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <LoadingButton
                                variant="contained"
                                fullWidth
                                color="error"
                                onClick={handleConfirm}
                                loading={cancelRequestTask.isRunning}
                                sx={{
                                    textTransform: 'none',
                                    height: '55px',
                                    fontWeight: 500,
                                    marginTop: 1,
                                }}
                            >
                                Potvrdiť zrušenie
                            </LoadingButton>
                            <Button
                                variant="text"
                                fullWidth
                                onClick={handleCloseBottomSheet}
                                disabled={cancelRequestTask.isRunning}
                                sx={{
                                    textTransform: 'none',
                                    color: 'text.secondary',
                                    fontWeight: 500,
                                }}
                            >
                                Zrušiť
                            </Button>
                        </Box>
                    </Box>
                </BottomSheet>
            )}
        </>
    );
};

export default CancelRequestButton;

